import { createActions } from "redux-actions";

export default createActions({
  TOP: {
    INDEX_OF_SIGNED_IN: {
      SET: (
        isWebViewTabApp,
        circles,
        newArrivalCircles,
        events,
        blogs,
        reports,
        currentUser,
        serviceId,
        userAgent
      ) => ({
        isWebViewTabApp,
        circles,
        newArrivalCircles,
        events,
        blogs,
        reports,
        currentUser,
        serviceId,
        userAgent,
      }),
    },
  },
});
